import { useContext, useState } from "react";
import PopupContext from "../../../context/context-popup";

import SidePopup from "../../../components/side-popup";
import List from "../../../components/list";
import InputsTextArea from "../../../components/inputs/inputs-text-area";
import { ButtonSave } from "../../../components/buttons";
import meetingsApi from "../../../lib/meetings/meetings-api";

export default function PopupsAdditionalPackageDetails({ data, edit = false, onAddonChange, onSuccess, booking, addon, addonPackage }) {
    const [ requirement, setRequirement ] = useState(edit === false ? addonPackage?.additional_requirements : data?.additional_requirements);
    const { closePopup } = useContext(PopupContext);

    const save = () => {
        meetingsApi.addAdditionalRequirementsToAddon(booking.id, addonPackage.id, {
            additional_requirements: requirement
        }).then(() => {
            onSuccess();
            closePopup();
        });
    }
    
    return (
        <SidePopup
            title={addon?.additional_requirements_label || 'Additional Requirements'}
        >
            <List gap="20px" height="-webkit-fill-available">
                { edit === false ? 
                    <>
                        <ButtonSave onClick={save}>Save</ButtonSave>
                        <InputsTextArea
                            placeholder="Enter Here"
                            value={requirement}
                            onChange={e => setRequirement(e.target.value)}
                            style={{
                                height: '100%'
                            }}
                        />
                    </> :
                    <>
                        <InputsTextArea
                            placeholder="Enter Here"
                            value={requirement}
                            style={{
                                height: '100%'
                            }}
                            onChange={e => {
                                onAddonChange(addonPackage.id, {
                                    target: {
                                        name: 'additional_requirements',
                                        value: e.target.value
                                    }
                                })
                                setRequirement(e.target.value);
                            }}
                        />
                    </>
                }
            </List>
        </SidePopup>
    )
}